<template>
  <div id="toy-zuojia">
    <ul class="flex-box">
      <li class="whiteB radius05rem" v-for="(n, index) in list" :key="index">
        <!--座驾图-->
        <div class="img overHidden relativeItem" v-if="type == 'zuojia'">
          <img class="centerImg" :src="n.images" />
        </div>
        <!--靓号-->
        <div class="img overHidden relativeItem" v-else>
          <img class="centerImg" src="../../assets/toy.png" />
          <p class="absoluteItem centerImg">{{ n.number }}</p>
        </div>

        <p class="name" v-if="type == 'zuojia'">{{ n.giftname }}</p>

        <div class="price flex-box">
          <img src="../../assets/icon (20).png" class="sign" />
          <span v-if="type == 'zuojia'">{{ n.giftprice }}/月</span>
          <span v-else>{{ n.price }}/月</span>
        </div>

        <div class="button flex-box" v-if="type == 'zuojia'">
          <div class="buy radius3" data-type="1" :data-id="n.giftid" @click="buy">购买</div>
          <div class="give radius3" data-type="0" :data-id="n.giftid" @click="show_send_tc">赠送</div>
        </div>
        <div class="button flex-box" v-else>
          <div class="buy radius3" data-type="1" :data-id="n.id" @click="buy">购买</div>
          <div class="give radius3" data-type="0" :data-id="n.id" @click="show_send_tc">赠送</div>
        </div>
      </li>
    </ul>

    <!--赠送弹窗-->
    <div id="toy-give-tc" class="tc" v-if="show_tc">
      <div class="centerImg shell radius05rem whiteB">
        <input type="number" v-model="tousernumber" placeholder="请输入你赠送人的靓号" />
        <div class="flex-box">
          <span @click="close_tc">取消</span>
          <span data-type="1" @click="buy_what">确定</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["list", "type"],
  data() {
    return {
      show_tc: false,
      tousernumber: "",
      goods_id: 0,
      buy_type: 1 //1为普通购买 0为赠送
    };
  },
  methods: {
    /**打开赠送弹窗 */
    show_send_tc(e) {
      this.goods_id = e.target.dataset.id;
      this.buy_type = e.target.dataset.type;
      this.show_tc = true;
    },
    /**关闭弹窗 */
    close_tc() {
      this.show_tc = !this.show_tc;
    },
    /**普通购买 */
    buy(e) {
      this.goods_id = e.target.dataset.id;
      this.buy_type = e.target.dataset.type;
      this.buy_what();
    },
    //判断是买车还是买靓号
    buy_what() {
      this.$tool.showLoading();
      let data = {
        type: this.buy_type,
        goodid: this.goods_id
      };
      if (this.buy_type == 0) {
        data.tousernumber = this.tousernumber;
      }
      // console.log(data);
      this.buy_send_car(data);
      this.show_tc = false;
    },
    //购买/赠送座驾
    buy_send_car(data) {
      let _this = this;
      let url = "";
      if (this.type == "zuojia") {
        //购买座驾接口
        url = this.$apis("buy_send_car");
      } else {
        //购买靓号接口
        url = this.$apis("buy_send_ling");
      }
      this.$jsonp(url, data, res => {
        if (res.body.ret == 200) {
          _this.$tool.tip(res.body.data.msg, "5rem");
          //通知父组件更新个人信息
          _this.$emit("upgrade", true);
        } else {
          _this.$tool.tip(res.body.msg, "5rem");
        }
        _this.$tool.hiddenLoading();
      });
    }
  },
  mounted: function() {},
  watch: {}
};
</script>








<style scoped lang="scss">
ul {
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0.8rem .7rem;
  padding-bottom: 4rem;
  li {
    width: 48%;
    padding-top: 0.5rem;
    padding-bottom: 0.8rem;
    margin-bottom: 0.8rem;
    .img {
      width: 10rem;
      height: 6.875rem;
      margin: 0 auto;
      p {
        font-size: 1.56rem;
        color: white;
        font-weight: bold;
      }
    }
    .name {
      margin-top: 0.4rem;
      font-size: 15px;
      text-align: center;
    }
    .price {
      margin-top: 0.5rem;
      align-items: center;
      justify-content: center;
      font-size: 13px;
      color: #999;
      img {
        width: 1rem;
        height: 1rem;
        margin-right: 4px;
      }
    }
    .button {
      padding: 0 0.8rem;
      margin-top: 0.8rem;
      align-items: center;
      justify-content: space-between;
      div {
        font-size: 12px;
        padding: 0.375rem 1.25rem;
        color: white;
      }
      .buy {
        background: linear-gradient(to right, #f6d365, #fda085);
      }
      .give {
        background: linear-gradient(to right, #fd79a8, #ff7675);
      }
    }
  }
}

.shell {
  width: 75%;
  padding: 0 1.5rem;
  input {
    display: block;
    width: 100%;
    margin-bottom: 1.6rem;
    margin-top: 1.6rem;
    border-bottom: 1px solid #19614d;
    font-size: 16px;
  }

  div {
    font-size: 14px;
    justify-content: space-around;
    margin-bottom: 10px;
  }
}
</style>
